import React from 'react'
import { TextPill } from 'components/FbUI/TextPill'
import { Preview, Section, Row } from 'component-catalog/previews/PreviewKit'

// StagePill requires live API data (sales stages fetched from backend) to render.
// This mock uses TextPill directly with representative stage colors.
export function StagePillMock(): React.ReactElement {
  return (
    <Preview>
      <Section label="Representative stage colors (via TextPill)">
        <Row>
          <TextPill backgroundColor="#e8f5e9" textColor="#1b5e20">
            Closed Won
          </TextPill>
          <TextPill backgroundColor="#e3f2fd" textColor="#0d47a1">
            Proposal
          </TextPill>
          <TextPill backgroundColor="#fff8e1" textColor="#7f4e00">
            Qualified
          </TextPill>
          <TextPill backgroundColor="#fce4ec" textColor="#880e4f">
            Closed Lost
          </TextPill>
          <TextPill backgroundColor="#f3e5f5" textColor="#4a148c">
            Negotiation
          </TextPill>
          <TextPill backgroundColor="#e0f2f1" textColor="#004d40">
            Prospecting
          </TextPill>
        </Row>
      </Section>
      <Section label="Note">
        <p className="text-xs text-fg-muted italic">
          StagePill fetches stage colors from the API at runtime. In the live
          app each stage pill reflects the actual color configured for that
          pipeline stage.
        </p>
      </Section>
    </Preview>
  )
}
